import {
  Box,
  Heading,
  Divider,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  Center,
  TableContainer,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";
// import axiosInstance from "../../utils/axiosInstance";
import * as mod from "../../url";
const SIDEBAR_WIDTH = "250px";

const Profile = () => {
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;
  const bgColor = useColorModeValue("white", "gray.800");

  const adminId = storedData?.data.superAdmin._id;
  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const { data } = await axios.get(
          `${mod.api_url}/api/v1/superAdmin/Super_admin_byid/${adminId}`,
          {
            headers: {
              Authorization: ` ${token}`,
            },
          }
        );
        setAdminData(data.admin);
      } catch (err) {
        console.error("API Error:", err.response || err.message);
        setError("Failed to fetch admin data");
      } finally {
        setLoading(false);
      }
    };

    if (adminId) {
      fetchAdmin();
    } else {
      setLoading(false);
      setError("Admin ID not found in session.");
    }
  }, [adminId]);

  if (error || !adminData) {
    return (
      <Center mt={10}>
        <Text color="red.500">{error || "No admin data found."}</Text>
      </Center>
    );
  }

  const { email, fullName, status, role, companyName } = adminData;

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        mt={{ base: "70px", md: "100px" }}
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
        px={{ base: 4, md: 8 }}
        py={6}
        minH="100vh"
        bgGradient="linear(to-r, gray.50, gray.100)"
      >
        <Box
          maxW="100%"
          mx="auto"
          p={6}
          borderRadius="2xl"
          bg={bgColor}
          boxShadow="2xl"
        >
          <Heading as="h2" size="xl" mb={4} textAlign="center" color="teal.600">
            Admin Profile
          </Heading>

          <Divider mb={6} borderColor="teal.300" />

          <TableContainer overflowX="auto">
            <Table variant="striped" size="md" colorScheme="teal">
              <Thead>
                <Tr>
                  <Th bg="teal.700" color="white">
                    Label
                  </Th>
                  <Th bg="teal.700" color="white">
                    Details
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td fontWeight="bold">Profile</Td>
                  <Td>
                    <Center>
                      {/* <Avatar size="xl" name={fullName} /> */}
                    </Center>
                  </Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Company Name</Td>
                  <Td>{companyName}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Email</Td>
                  <Td>{email}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Admin Name</Td>
                  <Td>{fullName}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Mobile</Td>
                  <Td>N/A</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Role</Td>
                  <Td>{role || "admin"}</Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
};

export default Profile;
